import { FC, memo, ReactElement } from 'react'
import { Center, Flex, Text, Spinner, BoxProps, Fade } from '@chakra-ui/react'

type Props = BoxProps & {
  children?: ReactElement
  text?: string
  direction?: 'column' | 'row'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  thickness?: string
  speed?: string
  emptyColor?: string
  color?: string
  isLoading?: boolean
}

const Loader: FC<Props> = ({
  direction = 'column',
  text,
  size,
  isLoading,
  thickness = '2px',
  speed = '0.65s',
  emptyColor,
  color = 'primary',
  height = '300px',
  children,
  ...rest
}) => {
  if (isLoading || !children) {
    return (
      <Fade in>
        <Center height={height} {...rest}>
          <Flex color={color} direction={direction} align="center" gap={4}>
            <Spinner thickness={thickness} speed={speed} emptyColor={emptyColor} size={size} />
            <Text textAlign="center" fontSize={size}>
              {text}
            </Text>
          </Flex>
        </Center>
      </Fade>
    )
  }

  return children
}

export default memo(Loader)
